export const baseUrl = 'https://api.agarwalprojects.com';
// export const baseUrl = 'http://localhost:7055';

export const loginUrl = baseUrl + '/auth/login';

export const adminUrl = 'https://users.agarwalprojects.com';
export const websiteUrl = 'https://agarwalprojects.com';
// export const websiteUrl = 'http://localhost:3000';

export const drawerWidth = 60;
export const expandDrawerWidth = 260;

export const fileTypes = ['jpeg', 'jpg', 'png', 'gif'];
export const videoTypes = ['mp4'];
